var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['item', {'active': _vm.show}]},[_c('div',{staticClass:"title",on:{"click":_vm.clickTitleHandler}},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]}),(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e()],2),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }